import React from 'react';
import { userSelectors } from '@marvelapp/marvel-3-application';
import { Badge, Flex, Link } from '@marvelapp/ui';
import SettingsToggle from '../SettingsToggle';
export default function InviteOnlyToggle({ title = 'Invite Only', description, isInviteOnly, onInviteOnlyChange, disabledTooltipText, currentUser, }) {
    function onSettingsToggleChange(e) {
        const newValue = e.target.checked;
        onInviteOnlyChange(newValue);
    }
    const showUpgradeBadge = userSelectors.isLockedFreePlan(currentUser);
    const toggleTitle = (React.createElement(InviteToggleTitle, { showUpgradeBadge: showUpgradeBadge, title: title }));
    return (React.createElement(SettingsToggle, { description: description, disabledTooltipText: disabledTooltipText, headingSize: 3, isChecked: isInviteOnly, mb: 5, onChange: onSettingsToggleChange, testId: "invite-only-toggle", title: toggleTitle }));
}
function InviteToggleTitle({ title, showUpgradeBadge }) {
    const badge = showUpgradeBadge ? (React.createElement(Link, { href: "/plans?intent=invite-only-projects" },
        React.createElement(Badge, { "data-testid": "invite-only-upgrade-badge", kind: "marvel", ml: 2 }, "Upgrade"))) : null;
    return (React.createElement(Flex, { alignItems: "center" },
        title,
        badge));
}
export function getInviteOnlyTooltip(currentUser, permissions, itemTypeString) {
    const isLockedFreePlan = userSelectors.isLockedFreePlan(currentUser);
    const canEditVisibility = permissions.canEditVisibility();
    if (isLockedFreePlan) {
        return `Invite only ${itemTypeString} are available on paid plans. Upgrade to unlock.`;
    }
    if (!canEditVisibility) {
        return `You don't have permissions to create invite-only ${itemTypeString}`;
    }
    return '';
}
